// external
import React, { useContext, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { change } from 'redux-form';
import ValidatedForm from '../../../components/molecules/ValidatedForm';
import Config from '../../utils/config';

// internal
import totalLoanValidator from '../../validators/totalLoan';
import stripLeadingZero from '../../utils/strip-leading-zero';
import stripNonNumeric from '../../utils/strip-non-numeric';
import style from './style';
import LanguageContext from '../../../context/language';
import { region } from '../../localizations/current-locale';
import FormTextBlock from '../GenericComponents/FormTextBlock/FormTextBlock';
import { dynamicBrand } from '../../utils/brand';
import devices from '../../styles/Devices';

let textResource;
import(`../../utils/text-resources/${dynamicBrand()}/${region}/messages`).then((m) => {
  textResource = m.default;
});

const Wrapper = styled.div`
  && {
    margin-top: ${(props) => (props.loanCalculatorOmalaina || style.totalAmountMarginTop)};
    @media ${devices.downFromTablet} {
      margin-top: ${(props) => (props.loanCalculatorOmalaina ? '0' : style.totalAmountMarginTop)};
  }
`;

const TotalAmountInput = ({
  whitelist,
  data,
  showErrors,
  formType,
}) => {
  const config = Config.getValues();
  const dispatch = useDispatch();

  const { lang } = useContext(LanguageContext);
  const changeField = (...args) => change('application', ...args);
  const values = useSelector((state) => state.form.application.values);
  const { totalAmount } = values;
  const { consolidationAmount } = values;
  const [maxValue, setMaxValue] = useState();
  const teamSwe = region === 'SE';
  const merge = values.merge === null || values.merge === true;
  const [showWarning, setShowWarning] = useState();

  useEffect(() => {
    dispatch(changeField('consolidationAmount', totalAmount));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalAmount]);

  useEffect(() => {
    if ((Number(totalAmount) - consolidationAmount > config.LOAN.NEW_LOAN_LIMIT + 1 && teamSwe)
    || (merge === false && teamSwe)) {
      setMaxValue(config.LOAN.NEW_LOAN_LIMIT);
      setShowWarning(true);
    } else {
      setMaxValue(config.LOAN.UP_TO);
    }
  }, [setMaxValue, setShowWarning, totalAmount, consolidationAmount, config, merge]); // eslint-disable-line

  return (
    <Wrapper
      loanCalculatorOmalaina={data?.calculator}
    >
      <ValidatedForm.Slider
        name={data.name}
        placeholder={data.placeholder}
        label={data.label}
        suffix={data.suffix}
        showButtons={data.showButtons}
        englishSuffix={lang === 'en'}
        type="tel"
        parse={(inputValue) => stripLeadingZero(stripNonNumeric(inputValue))}
        maxLength={String(maxValue).length + 1} // Take space between numbers into account
        validate={totalLoanValidator}
        showErrors={showErrors}
        tooltip={data.tooltip}
        formType={formType}
        totalAmountField
        sliderConfig={{
          range: {
            min: config.LOAN.FROM,
            max: teamSwe ? maxValue || config.LOAN.NEW_LOAN_LIMIT : config.LOAN.UP_TO,
          },
          step: config.LOAN.STEP,
        }}
        withTextInput
        labelOutside
        whitelist={whitelist}
        fieldStyle={data.fieldStyle}
        loanCalculatorStyle={data.loanCalculatorStyle}
      />
      {showWarning && (
      <FormTextBlock
        data={{
          text: textResource.newLoanLimitWarning,
          transparent: false,
          margin: false,
          special: true,
          center: true,
        }}
      />
      )}
    </Wrapper>
  );
};

TotalAmountInput.propTypes = {
  data: PropTypes.shape(),
  whitelist: PropTypes.bool,
  showErrors: PropTypes.bool,
  formType: PropTypes.string,
};

TotalAmountInput.defaultProps = {
  data: {},
  whitelist: false,
  showErrors: false,
  formType: '',
};

export default TotalAmountInput;
